module.exports = __webpack_public_path__ + "static/img/byconcept-03.85cec8f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/byconcept-03.webp
// module id = 69
// module chunks = 0